import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { axiosInt, type IScreen, API_INTERACT_URL } from '..';

export const FETCH_RESOLVE_SCREEN_KEY = 'fetchResolveScreen';
export const fetchResolveScreenApi = async (id: string): Promise<IScreen> => {
  const response = await axiosInt.get(
    `${API_INTERACT_URL}/screens/read/model-instance/${id}`
  );
  return response.data;
};

export const useResolveScreen = (
  id: string,
  options?: Partial<
    UseQueryOptions<IScreen, Error, IScreen, readonly unknown[]>
  >
) => {
  const {
    data: screen,
    isLoading: isLoadingScreen,
    error: errorFetchingScreen,
  } = useQuery<IScreen, Error, IScreen, readonly unknown[]>({
    queryKey: [FETCH_RESOLVE_SCREEN_KEY, id],
    queryFn: () => fetchResolveScreenApi(id),
    ...options,
  });

  return { screen, isLoadingScreen, errorFetchingScreen };
};
